import Grid from "@mui/material/Grid2";
import SubscriptionsCard from "./subscriptioncard";
import UsageRateCard from "./usageratecard";
import GeographicDistributionCard from "./geographiccard";
import { DateRange } from "../api/types";

type DashboardContentProps = {
  dateRange: DateRange | null;
  isWalkthroughActive?: boolean;
  walkthroughProductFilterOpen?: boolean;
};

const DashboardContent = ({ dateRange, isWalkthroughActive, walkthroughProductFilterOpen }: DashboardContentProps) => {
  return (
    <Grid container spacing={3}>
      <Grid size={{ mobile: 12, tablet: 12, laptop: 6, desktop: 6 }}>
        <UsageRateCard dateRange={dateRange} isWalkthroughActive={isWalkthroughActive} />
      </Grid>

      <Grid size={{ mobile: 12, tablet: 12, laptop: 6, desktop: 6 }}>
        <SubscriptionsCard dateRange={dateRange} isWalkthroughActive={isWalkthroughActive} />
      </Grid>
      <Grid size={{ mobile: 12, tablet: 12, laptop: 12, desktop: 12 }}>
        <GeographicDistributionCard isWalkthroughActive={isWalkthroughActive} walkthroughProductFilterOpen={walkthroughProductFilterOpen} />
      </Grid>
    </Grid>
  );
};

export default DashboardContent;
